import PasswordIcon from '@mui/icons-material/Password';
import {Box, Grid, IconButton, Stack} from "@mui/material";

// import { vestResolver } from "@hookform/resolvers/vest";
// import validators from "./validators";

import {useState} from "react";

import {Controller, useForm} from "react-hook-form";
import {submitChangePassword} from "@/services/auth";
import {useNotificationContext} from "@/contexts/NotificationContext.tsx";
import {UICardContent, UICardHeadingLight} from "@/components/Shared/Utils/UICard";
import Utils from "@/components/Shared/Utils";

export default function ManagePassword() {
    const [isLoading, setLoading] = useState<boolean>(false);
    const [type, setType] = useState<string>('password');

    const {notification, setNotification} = useNotificationContext();

    const {
        control,
        handleSubmit,
        formState: {
            errors,
            isDirty
        }
    } = useForm({
        defaultValues: {
            password: "",
            new_password: "",
            new_password_confirmation: ""
        }
    });

    function handleChangePassword(payload: any) {
        setLoading(true);

        submitChangePassword(payload).then(({data, errors}) => {
            setLoading(false)

            if (errors) {
                return setNotification({...notification, message: errors?.[0]?.message, severity: 'error', open: true})
            }

            if (data) {
                setNotification({...notification, message: data.message, severity: 'success', open: true})
            }
        })
    }

    return (
        <>
            <UICardHeadingLight title="Change Password"
                           description="Change your password for worry-free logins."/>
            <UICardContent>
                <Box p={2}>
                    <Grid container>
                        <Grid item md={4} xs={12}>
                            <Box component="form">
                                <Box mb={2}>
                                    <Controller
                                        name="password"
                                        defaultValue=""
                                        control={control}
                                        render={({field}) => (
                                            <Utils.FormUtils.PrimaryInput
                                                {...field}
                                                type={type}
                                                label="Current Password (*)"
                                                error={!!errors?.password}
                                                helperText={errors?.password?.message as string}
                                            />
                                        )}
                                    />
                                </Box>

                                <Box mb={2}>
                                    <Stack direction="row" position="relative">
                                        <Controller
                                            name="new_password"
                                            defaultValue=""
                                            control={control}
                                            render={({field}) => (
                                                <Utils.FormUtils.PrimaryInput
                                                    {...field}
                                                    type={type}
                                                    label="Password (*)"
                                                    error={!!errors?.new_password}
                                                    helperText={errors?.new_password?.message as string}
                                                />
                                            )}
                                        />
                                        <IconButton aria-label="show" sx={{position: 'absolute', top: 0, right: 0}}
                                                    onClick={() => setType(type === 'password' ? 'text' : 'password')}>
                                            <PasswordIcon sx={{fontSize: 20}}/>
                                        </IconButton>
                                    </Stack>
                                </Box>

                                <Box mb={2}>
                                    <Controller
                                        name="new_password_confirmation"
                                        defaultValue=""
                                        control={control}
                                        render={({field}) => (
                                            <Utils.FormUtils.PrimaryInput
                                                {...field}
                                                type={type}
                                                label="Password Confirmation (*)"
                                                error={!!errors?.new_password_confirmation}
                                                helperText={errors?.new_password_confirmation?.message as string}
                                            />
                                        )}
                                    />
                                </Box>

                                <Utils.AsyncButton
                                    text="Update Password"
                                    disabled={isLoading || !isDirty}
                                    isLoading={isLoading}
                                    callback={handleSubmit(handleChangePassword)}
                                />
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </UICardContent>
        </>
    )
}